import { Box, Paper, Typography } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import Boundary from "models/geospatial/boundary";
import Point from "models/geospatial/point";
import Input from "models/input/input";
import React from "react";
import { MetadataPlacement } from "models/input/metadata-placement";
import Metadata from "./metadata/Metadata";
import Footer from "./footer";
import Template from "models/template";

function MetadataCard({
  input,
  templates,
  boundaries,
  points,
  placement,
}: Readonly<{
  input: Input;
  templates: Template[];
  boundaries: Boundary[];
  points: Point[];
  placement: MetadataPlacement;
}>) {
  const theme = useEasierTheme();

  return (
    <Paper sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          p: 2,

          ...(["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? { background: "#E35205" }
            : {
                background: theme?.Colour.Primary(),
                borderRadius: "8px 8px 0px 0px",
              }),
        }}
      >
        <Typography
          variant="h3"
          sx={{
            m: "auto auto auto 0px",
            ...(["FAF-nt", "nrdata-orig"].includes(
              process.env.REACT_APP_STYLING_THEME ?? "",
            )
              ? {
                  lineHeight: 1.6,
                  letterSpacing: 0.3,
                  fontSize: "0.9rem",
                  fontWeight: 450,
                  color: theme?.Colour.OnSecondary(),
                }
              : { color: theme?.Colour.OnPrimary() }),
          }}
        >
          Metadata
        </Typography>
      </Box>
      <Box p={2}>
        <Metadata
          input={input}
          boundaries={boundaries}
          points={points}
          placement={placement}
          templates={templates}
        />
      </Box>
      <Footer input={input} boundaries={boundaries} points={points} />
    </Paper>
  );
}

export default MetadataCard;
